/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file HemoglobinView.jsx
 * @author Daniel Aguirre
 * @description Hemoglobin View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import DashboardDoughnut from 'components/Charts/DashboardDoughnut';
import styleGuideColors from 'commons/styleGuideColors';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import useTruncateAndFormat from 'hook/useTruncateAndFormat';

/**
 * Hemoglobin View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function HemoglobinView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState([]);

  const { getHemoglobin } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    let data = [];
    const classifications = [
      {
        label: 'Menos de 10',
        color: styleGuideColors.alertError
      },

      {
        label: 'Mas de 10',
        color: styleGuideColors.baxterBrandTeal
      }
    ];

    let total = 0;

    if (resp?.data) {
      resp.data.forEach(({ cantidad }) => {
        total += cantidad;
      });
      classifications.forEach(({ label, color }) => {
        const respElement = resp.data.find(
          ({ clasificacion }) => clasificacion === label
        );
        if (respElement) {
          const value = (respElement.cantidad * 100) / total;
          data = [
            ...data,
            {
              value: useTruncateAndFormat(value, 2),
              label: translate(`dashboardStaff.${label}`),
              key: label,
              color,
              cantidad: respElement.cantidad
            }
          ];
        }
      });
      setChartData(data);
    }
  };

  useEffect(() => {
    setChartData(null);
    getHemoglobin({ clinicId }, onGetData);
  }, [clinicId, translate]);

  const handleDetailClick = (index) => {
    const { key: clasificacionSeleccionada, cantidad: totalItems } =
      chartData[index];
    history.push(
      `/main/dashboard-detail/hemoglobin/${clasificacionSeleccionada}/${totalItems}`
    );
  };

  return chartData ? (
    <DashboardDoughnut
      dataValues={chartData}
      onDetailClick={handleDetailClick}
    />
  ) : (
    <Spin />
  );
}

/**
 * Component definition of proptypes.
 */
HemoglobinView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getHemoglobin: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default HemoglobinView;
